
document.addEventListener('DOMContentLoaded', function() {
    function updateFraction(swiper, fractionId) {
        var currentSlide = swiper.realIndex + 1;
        var totalSlides = swiper.slides.length;
        document.getElementById(fractionId).textContent = currentSlide + ' / ' + totalSlides;
    }

    var swiperReviews = new Swiper('.swiper-reviews', {
        slidesPerView: 'auto',
        spaceBetween: 3 * (window.innerWidth / 100), // Converts 2vw to pixels
        grabCursor: true,
        freeMode: true,
        freeModeMomentum: true,
        autoHeight: true, // Enables auto height
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'fraction', // Use fractional pagination
        },
   navigation: {
        nextEl: '.button-next',
        prevEl: '.button-prev',
        },
        on: {
            init: function () {
                updateFraction(this, 'swiper-pagination-fraction-reviews');
            },
            slideChange: function () {
                updateFraction(this, 'swiper-pagination-fraction-reviews');
            }
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    function updateFraction(swiper, fractionId) {
        var currentSlide = swiper.realIndex + 1;
        var totalSlides = swiper.slides.length;
        document.getElementById(fractionId).textContent = currentSlide + ' / ' + totalSlides;
    }

    var swiperReviews = new Swiper('.swiper-team', {
        slidesPerView: 'auto',
        spaceBetween: 3 * (window.innerWidth / 100), // Converts 2vw to pixels
        grabCursor: true,
        freeMode: true,
        freeModeMomentum: true,
        autoHeight: true, // Enables auto height
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'fraction', // Use fractional pagination
        },
        navigation: {
          nextEl: '.button-next',
        prevEl: '.button-prev',
        },
        on: {
            init: function () {
                updateFraction(this, 'swiper-pagination-fraction-reviews');
            },
            slideChange: function () {
                updateFraction(this, 'swiper-pagination-fraction-reviews');
            }
        }
    });
});









$('.menu-toggle').on('click', function() {
    $('.full-menu').toggleClass('active');
    // Check the current text and toggle it
    if ($(this).text() === "Close") {
        $(this).text("Menu"); // Change back to Menu or your original text
    } else {
        $(this).text("Close");
    }
});







const init = () => {
  // Select all marquees
  const marquees = document.querySelectorAll('[wb-data="marquee"]');
  marquees.forEach((marquee) => {
    const baseSpeed = 50; // Speed in pixels per second

    const marqueeContent = marquee.firstChild;
    if (!marqueeContent) {
      return;
    }

    const marqueeContentClone = marqueeContent.cloneNode(true);
    marquee.append(marqueeContentClone);

    let tween;

    const playMarquee = () => {
      let progress = tween ? tween.progress() : 0;
      tween && tween.progress(0).kill();

      // Calculate total width (content width + gap)
      const width = parseInt(getComputedStyle(marqueeContent).width, 10);
      const gap = parseInt(getComputedStyle(marqueeContent).getPropertyValue("column-gap"), 10) || 0; // Fallback to 0 if gap is not defined
      const totalWidth = width + gap;

      // Calculate duration to maintain a consistent speed across marquees
      const duration = totalWidth / baseSpeed; // Time = Distance / Speed

      tween = gsap.fromTo(
        marquee.children,
        { x: 0 },
        { x: -totalWidth, duration, ease: "none", repeat: -1 }
      );
      tween.progress(progress);
      console.log({ totalWidth, duration, speed: baseSpeed });
    };
    playMarquee();

    function debounce(func, wait) {
      let timer;
      return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), wait);
      };
    }

    window.addEventListener("resize", debounce(playMarquee, 100));
  });
};

document.addEventListener("DOMContentLoaded", init);



// SCROLL FLIP POWER-UP
window.addEventListener("DOMContentLoaded", (event) => {
  // attribute value checker
  function attr(defaultVal, attrVal) {
    const defaultValType = typeof defaultVal;
    if (typeof attrVal !== "string" || attrVal.trim() === "") return defaultVal;
    if (attrVal === "true" && defaultValType === "boolean") return true;
    if (attrVal === "false" && defaultValType === "boolean") return false;
    if (isNaN(attrVal) && defaultValType === "string") return attrVal;
    if (!isNaN(attrVal) && defaultValType === "number") return +attrVal;
    return defaultVal;
  }
  gsap.registerPlugin(ScrollTrigger, Flip);
  ScrollTrigger.normalizeScroll(false);
  // scrollflip component
  $("[tr-scrollflip-element='component']").each(function (index) {
    let componentEl = $(this),
      originEl = componentEl.find("[tr-scrollflip-element='origin']"),
      targetEl = componentEl.find("[tr-scrollflip-element='target']"),
      scrubStartEl = componentEl.find("[tr-scrollflip-scrubstart]"),
      scrubEndEl = componentEl.find("[tr-scrollflip-scrubend]");
    let startSetting = attr("top top", scrubStartEl.attr("tr-scrollflip-scrubstart")),
      endSetting = attr("bottom bottom", scrubEndEl.attr("tr-scrollflip-scrubend")),
      staggerSpeedSetting = attr(0, componentEl.attr("tr-scrollflip-staggerspeed")),
      staggerDirectionSetting = attr("start", componentEl.attr("tr-scrollflip-staggerdirection")),
      scaleSetting = attr(false, componentEl.attr("tr-scrollflip-scale")),
      breakpointSetting = attr(0, componentEl.attr("tr-scrollflip-breakpoint"));
    let componentIndex = index,
      timeline,
      resizeTimer;
    // asign matching data flip ids
    originEl.each(function (index) {
      let flipId = `${componentIndex}-${index}`;
      $(this).attr("data-flip-id", flipId);
      targetEl.eq(index).attr("data-flip-id", flipId);
    });
    // create timeline
    function createTimeline() {
      if (timeline) {
        timeline.kill();
        gsap.set(targetEl, { clearProps: "all" });
      }
      $("body").addClass("scrollflip-relative");
      gsap.matchMedia().add(`(min-width: ${breakpointSetting}px)`, () => {
        const state = Flip.getState(originEl);
        timeline = gsap.timeline({scrollTrigger: { trigger: scrubStartEl, endTrigger: scrubEndEl, start: startSetting, end: endSetting, scrub: true }});
        timeline.add(Flip.from(state, { targets: targetEl, scale: scaleSetting, stagger: { amount: staggerSpeedSetting, from: staggerDirectionSetting }}));
      });
      $("body").removeClass("scrollflip-relative");
    }
    createTimeline();
    // update on window resize
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        createTimeline();
      }, 250);
    });
  });
});

  
